import React from 'react';
import {ModalFactory, ModalOptions} from './types';

const ModalContext = React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  openModal<R>(modalFactory: ModalFactory<R>, modalOptions: ModalOptions<R> = {}): Promise<R | false> {
    throw new Error('Provider required');
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  closeModal(modalId: string, isForce: boolean = false): void {
    throw new Error('Provider required');
  },
  closeAllModal(isForce: boolean = false): void {
    throw new Error('Provider required');
  },
});

export default ModalContext;
